import styled from 'styled-components';

export const ContactSection = styled.section`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3rem;
  width: 100%;
  will-change: contents;
  z-index: 1;
  transform-style: preserve-3d;
  animation: fadeIn 1s forwards;
  animation-delay: 2.5s;
  opacity: 0;
  padding-top: 0rem;

  @media (max-width: 1020px) {
    padding-right: 2rem;
  }
  @media (max-width: 900px) {
    padding: 3rem;
    grid-gap: 3rem;
  }
  @media (max-width: 925px) {
    flex-direction: column-reverse;
  }
  @media (max-width: 500px) {
    padding: 2rem;
  }
  @media (max-width: 360px) {
    padding: 1.4rem;
  }
  @media (max-width: 300px) {
    padding-right: 0.7rem;
  }

  h1 {
    font-size: 43px;
    color: #3bcfe3;
    font-weight: 400;
    font-family: 'Lato', sans-serif;
    margin-top: 0;
    position: relative;
    margin-bottom: 30px;
    left: -10px;

    &:before {
      content: '<h1>';
      font-family: 'La Belle Aurore', cursive;
      color: #3bcfe3;
      font-size: 18px;
      position: absolute;
      margin-top: -10px;
      left: -10px;
      opacity: 0.3;
      line-height: 18px;
    }

    &:after {
      content: '<h1/>';
      font-family: 'La Belle Aurore', cursive;
      color: #3bcfe3;
      font-size: 18px;
      line-height: 18px;
      position: absolute;
      left: -30px;
      bottom: -20px;
      margin-left: 20px;
      opacity: 0.3;
    }
  }

  p {
    
    font-size: clamp(1rem, 2.5vw, 1.2rem);
    line-height: 26px;
    letter-spacing: 0.05rem;
    word-spacing: 0.15rem;
    color: #D6D6D6;
    font-weight: 300;
    max-width: fit-content;
  }

  .text-zone {
    z-index: 2;
    width: 47%;
    vertical-align: middle;
    display: table-cell;
    max-height: 90%;

    @media (max-width: 1180px) {
      width: 57%;
    }
    @media (max-width: 925px) {
      max-width: 45rem;
      width: 100%;
    }
  }

  .img-zone {
    width: 38%;

    @media (max-width: 725px) {
      max-width: 27rem;
      width: 78%;
    }
    @media (max-width: 300px) {
      margin-bottom: -2rem;
    }
    // opacity: 0.15;
    z-index: -1;
  }

  .contact-form {
    width: 100%;
    margin-top: 20px;

    ul {
      padding: 0;
      margin: 0;

      li {
        padding: 0;
        margin: 0;
        list-style: none;
        margin-bottom: 10px;
        opacity: 0;
        overflow: hidden;
        display: block;
        clear: both;
        position: relative;
        animation: fadeInUp 2s 2s;
        animation-fill-mode: forwards;
      }

      li.half {
        width: 49%;
        margin-left: 2%;
        float: left;
        clear: none;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    input[type='text'],
    input[type='email'] {
      width: 100%;
      border: 0;
      background: #115173;
      height: 50px;
      font-size: 0.8rem;
      color: #fff;
      padding: 0 17px;
      box-sizing: border-box;
    }

    textarea {
      width: 100%;
      border: 0;
      background: #115173;
      height: 40px;
      font-size: 0.8rem;
      color: #fff;
      padding: 20px;
      box-sizing: border-box;
      min-height: 150px;
    }

    .flat-button {
      color: #3bcfe3;
      font-size: 11px;
      letter-spacing: 3px;
      text-decoration: none;
      padding: 8px 10px;
      border: 1px solid #3bcfe3;
      float: left;
      border-radius: 4px;
      background: 0 0;
      text-transform: uppercase;
      float: right;
      text-align: center;
      margin-right: 10px;
    }
  }
`;
